<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Your Referral</div>
    </template>

    <div class="d-flex flex-column" style="width: 100%">
      <!-- Customer Section -->
      <Section>
        <template #header>
            <strong style="color:black">Request</strong>
        </template>

        <Item icon="mdi-home-group">{{ this.settings.structure_types[currentRequest.structure_type] }}</Item>
        <Item icon="mdi-account">{{ currentRequest.name }}</Item>
        <Item icon="mdi-phone">{{ currentRequest.phone }}</Item>
      </Section>

      <!-- Service -->
      <Section v-if="currentService">
        <template #header>
          <strong style="color:black">Service Requested</strong>
        </template>

        <div class="pl-2">
          {{ prettyStructureType }} / {{ currentService.service }}
        </div>
      </Section>

      <!-- Service -->
      <Section v-if="currentRequest.notes">
        <template #header>
          <strong style="color:black">Additional notes for the Pro</strong>
        </template>

        <div class="pl-2">
          {{ currentRequest.notes }}
        </div>
      </Section>

      <div class="mt-8 d-flex justify-center">
        <v-btn 
          width="60%" 
          color="primary"
          @click="confirmClick"
        >
          Confirm
        </v-btn>
      </div>

      <div class="mt-4 d-flex justify-center">
        <v-btn :to="{ name: 'referrals' }" width="60%">Cancel</v-btn>
      </div>

      <v-overlay absolute :value="overlay">
        <div class="d-flex flex-column align-center">
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="primary"
            v-if="loading"
          ></v-progress-circular>
          <ConfirmationDialog v-model="confirmedDialog" @done="doneClick"/>
        </div>
      </v-overlay>
    </div>
  </ContentPage>
</template>


<script>
import ConfirmationDialog from './ConfirmationDialog'
import { ContentPage, Section, Item } from '@/components/pages'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: { ConfirmationDialog, ContentPage, Section, Item },

  props: {
    automatic: { type: Boolean, default: false }
  },

  data() {
    return {
      overlay: false,
      loading: false,
      confirmedDialog: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['settings']),
    ...mapGetters('referrals', ['currentService', 'currentRequest', 'currentPros']),

    prettyStructureType() {
      if (!this.settings?.structure_types)
        return ""

      return this.settings.structure_types[this.currentRequest.structure_type]
    },
  },

  methods: {
    ...mapActions('auth', ['loadSettings']),
    ...mapActions('referrals', ['createReferralsWithNewRequest']),
    ...mapMutations('referrals', ['clearAll']),

    async confirmClick() {
      this.overlay=true
      this.loading=true

      const payload = {
        customer_request: { 
          ...this.currentRequest,
          request_type: this.automatic ? 'automatic' : 'manual',
        },
      }

      if (!this.automatic) {
        payload.pro_ids = this.currentPros.map( p => p.pro_id )
      }

      const result = await this.createReferralsWithNewRequest(payload)
      if (result.ok) {
        this.loading = false
        this.confirmedDialog = true
      } else {
        console.log('referral creation failed')
        this.overlay = false
      }
    },

    async doneClick() {
      await this.$router.push( { name: 'leads/list' })
      this.overlay=false
      this.clearAll()
    }
  },

  created() {
    if (!this.currentService) {
      this.$router.push({ name: 'referrals' })
    }

    this.loadSettings()
  },
}

</script>